var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('BannerContabilidad'),_c('Gestion'),_c('InformationSec'),_c('CTACont'),_c('AllYouNeed')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }